var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attr-channel"},[_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":_vm.changeChannel},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }